import { render, staticRenderFns } from "./BaseTree.vue?vue&type=template&id=0477a616&"
import script from "./BaseTree.vue?vue&type=script&lang=js&"
export * from "./BaseTree.vue?vue&type=script&lang=js&"
import style0 from "./BaseTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports